import { AllActions } from "../actions";
import { StoreState } from "../types";
import * as constants from "../constants";

export function columns(
  state: StoreState.Columns,
  action: AllActions,
): StoreState.Columns {
  if (state === undefined) {
    state = null;
  }
  switch (action.type) {
    case constants.RECEIVE_COLUMNS:
      return action.data;
  }
  return state;
}
